/**
 * https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser
 */

Drupal.behaviors.gutfeelingDetectExtinctBrowsers = {
  attach: function (context) {
    // Internet Explorer 6-11
    let isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    let isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1 - 79
    let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    // Edge (based on chromium) detection
    let isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);

    if (isIE || (isEdge && !isEdgeChromium)) {
      let body = window.document.getElementsByTagName('html')[0];
      body.classList.add('browser-warning');
    }
  }
};
